import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [RouterLink],
  template: `
    <footer class="footer">
      <div class="footer-content">
        <div class="footer-main">
          <img src="assets/Artvarken-tricolore.jpg" alt="Artvarken" class="mascot" />
          <div class="footer-info">
            <p class="footer-title">APK Gent - Academie Podiumkunsten</p>
            <p class="footer-subtitle">Woord • Muziek • Dans • Kunstenbad</p>
          </div>
        </div>
        <div class="footer-links">
          <a routerLink="/admin" class="admin-link">Admin</a>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; {{ currentYear }} APK Gent</p>
      </div>
    </footer>
  `,
  styles: [`
    .footer {
      background: #2c3e50;
      color: white;
      padding: 2rem 1rem 1rem;
      margin-top: auto;
    }

    .footer-content {
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 1rem;
    }

    .footer-main {
      display: flex;
      align-items: center;
      gap: 1rem;
    }

    .mascot {
      height: 60px;
      width: auto;
      border-radius: 8px;
    }

    .footer-info {
      display: flex;
      flex-direction: column;
    }

    .footer-title {
      font-weight: 600;
      margin: 0;
    }

    .footer-subtitle {
      opacity: 0.8;
      margin: 0;
      font-size: 0.9rem;
    }

    .footer-links {
      display: flex;
      gap: 1rem;
    }

    .admin-link {
      color: rgba(255, 255, 255, 0.6);
      text-decoration: none;
      font-size: 0.85rem;
      transition: color 0.2s;
    }

    .admin-link:hover {
      color: white;
    }

    .footer-bottom {
      max-width: 1200px;
      margin: 1.5rem auto 0;
      padding-top: 1rem;
      border-top: 1px solid rgba(255, 255, 255, 0.1);
      text-align: center;
      font-size: 0.85rem;
      opacity: 0.7;
    }

    .footer-bottom p {
      margin: 0;
    }

    @media (max-width: 600px) {
      .footer-content {
        flex-direction: column;
        text-align: center;
      }

      .footer-main {
        flex-direction: column;
      }
    }
  `]
})
export class FooterComponent {
  currentYear = new Date().getFullYear();
}
